import { render, staticRenderFns } from "./pdf-page.vue?vue&type=template&id=8c895dfe&scoped=true"
import script from "./pdf-page.vue?vue&type=script&lang=ts"
export * from "./pdf-page.vue?vue&type=script&lang=ts"
import style0 from "./pdf-page.vue?vue&type=style&index=0&id=8c895dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c895dfe",
  null
  
)

export default component.exports